import { Controller } from "@hotwired/stimulus"

// Toggles form fields based on asset_type selection.
// Bitcoin: just quantity + cost basis (name/ticker auto-set, price auto-fetched).
// Other types: show name + manual value fields.
export default class extends Controller {
  static targets = ["assetType", "nameField", "nameInput", "manualValueField", "quantityField"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const type = this.assetTypeTarget.value
    const isBitcoin = type === "bitcoin"

    // Bitcoin: hide name + current value, show amount + cost basis grid
    // Non-Bitcoin: show name + current value, hide amount + cost basis grid
    if (this.hasNameFieldTarget) {
      this.nameFieldTarget.classList.toggle("hidden", isBitcoin)
    }
    if (this.hasManualValueFieldTarget) {
      this.manualValueFieldTarget.classList.toggle("hidden", isBitcoin)
    }
    if (this.hasQuantityFieldTarget) {
      this.quantityFieldTarget.classList.toggle("hidden", !isBitcoin)
    }
    if (this.hasNameInputTarget) {
      const placeholders = {
        investment_account: "e.g., Wealthfront Buy & Hold",
        real_estate: "e.g., 123 Main St",
        other: "e.g., Gold, Art collection"
      }
      this.nameInputTarget.placeholder = placeholders[type] || ""
    }
  }
}
